import { render, staticRenderFns } from "./CalendarBox.vue?vue&type=template&id=251d6893&scoped=true&"
import script from "./CalendarBox.vue?vue&type=script&lang=js&"
export * from "./CalendarBox.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBox.vue?vue&type=style&index=0&id=251d6893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251d6893",
  null
  
)

export default component.exports